import { render, staticRenderFns } from "./MatchingPhonics1.vue?vue&type=template&id=553398de&scoped=true&"
import script from "./MatchingPhonics1.vue?vue&type=script&lang=js&"
export * from "./MatchingPhonics1.vue?vue&type=script&lang=js&"
import style0 from "./MatchingPhonics1.vue?vue&type=style&index=0&id=553398de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553398de",
  null
  
)

export default component.exports